import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'virtues-bootstrap';
import s from './styles.module.scss';

const FileInput = ({ input, meta }) => {
  const [fileCount, setFileCount] = useState(0);

  const onChange = e => {
    const files = [...e.target.files];
    input.onChange(files);
    setFileCount(files.length);
  };

  return (
    <div>
      <Button type="button" stretch outlined>
        <input className={s.input} type="file" accept=".pdf" multiple onChange={onChange} />
        {fileCount ? `Upload ${fileCount} files` : `Upload`}
      </Button>
      {meta.touched && meta.error && <span className="error">{meta.error}</span>}
    </div>
  );
};

FileInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.shape({}),
    touched: PropTypes.bool,
  }).isRequired,
};

export default FileInput;
